module.exports = __webpack_public_path__ + "static/media/landmark-home-warranty-news-blog.0285aaf0.jpg";